export default "__VITE_ASSET__DkI4qAKW__"